export default {
  total_orders: {
    title: 'Encomendas',
    orders: 'Encomendas:',
    sales_volume: 'Volume de vendas:',
    delivery_costs: 'Custos de entrega:',
  },
  cash_orders: {
    title: 'Pagamento em dinheiro/ à porta',
    orders: 'Encomendas:',
    sales_volume: 'Volume de vendas:',
    delivery_costs: 'Custos de entrega:',
  },
  online_orders: {
    title: 'Pagamentos online',
    orders: 'Encomendas:',
    sales_volume: 'Volume de vendas:',
    delivery_costs: 'Custos de entrega:',
  },
  total: 'Total',
  collected_taxes_list: {
    title: {
      online: 'Pagamento online',
      cash: 'Pagamento em dinheiro',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Produto',
          quantity: 'Quantidade',
          total: 'Total',
        },
        labels: {
          total_refunded: 'Reembolsado',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'IVA %',
          product_type: 'Tipo',
          netto: 'Líquido',
          tax: 'IVA',
          brutto: 'Total',
        },
        product_types: {
          product: 'Produtos {{percentage}}%',
          order_method_fee: 'Taxas de entrega {{percentage}}%',
          customer_service_fee: 'Sobretaxa online',
        },
      },
    },
  },
};
